/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ObjectComment } from '@pwc/pwc-deals-ui';
import { useSelector } from 'react-redux';
import useAutoLock from 'common/hooks/useAutoLock';
import {
  getFakeClientUser,
  getIsThirdPartyMember,
} from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { useIsPreviousVersionSelected } from 'common/hooks/useIsPreviousVersionSelected';
import { useIsAddingCommentEnabled } from '../hooks/useIsAddingCommentEnabled';

interface NestedWrapperProps {
  libraryItemId: number;
  isCommentingEnabled: boolean;
}

const ObjectCommentWithLock: React.FC<NestedWrapperProps> = ({
  libraryItemId,
  isCommentingEnabled,
  children,
}) => {
  const { isLocked } = useAutoLock();
  const isFakeClientUser = useSelector(getFakeClientUser);
  const isThirdPartyMember = useSelector(getIsThirdPartyMember);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  let isAddingCommentEnabled = useIsAddingCommentEnabled();
  const isPreviousVersionSelected = useIsPreviousVersionSelected();

  // TODO: revisit this, isCommentingEnabled can be undefinned and is marked as required as type
  if (typeof isCommentingEnabled !== 'undefined' && !isCommentingEnabled) {
    isAddingCommentEnabled = false;
  }

  return (
    <ObjectComment
      libraryItemId={libraryItemId}
      isCommentingEnabled={
        isAddingCommentEnabled && !isFakeClientUser && !isThirdPartyMember
      }
      isContentLocked={isLocked}
      showAddComment={!isPreviousVersionSelected}
    >
      {children}
    </ObjectComment>
  );
};

interface Props {
  libraryItemId: number;
  isCommentingEnabled: boolean;
}

const ObjectCommentWrapper: React.FC<Props> = ({
  libraryItemId,
  isCommentingEnabled,
  children,
}) => {
  return (
    <ObjectCommentWithLock
      libraryItemId={libraryItemId}
      isCommentingEnabled={isCommentingEnabled}
    >
      {children}
    </ObjectCommentWithLock>
  );
};

export default ObjectCommentWrapper;
